import Vue, { VueConstructor } from "vue";
import AppointmentsItemRequestView from "./AppointmentsItemRequestView";
import AppointmentsItemUpcomingView from "./AppointmentsItemUpcomingView";
import { AppointmentsTabNameEnum } from "../../../config";

export function getAppointmentView(viewMode: AppointmentsTabNameEnum): VueConstructor<Vue> {
  switch (viewMode) {
    case AppointmentsTabNameEnum.REQUESTS:
      return AppointmentsItemRequestView;
    default:
      return AppointmentsItemUpcomingView;
  }
}
